import { Box } from "@/layouts/LayoutComponents";
import classNames from "classnames";
// import { Box } from "@fastlooptech/layout-components";

interface CarouselControlProps {
  "data-test-id"?: string;
  /**
   * The class name of the SilderControl.
   * @type string
   */
  className?: string;
  /**
   * The index of the CarouselControl.
   * @type number
   * @required
   */
  index: number;
  /**
   * The variant of the CarouselControl. The variant can be either "inactive" or "active".
   * @type "inactive" | "active"
   * @default "inactive"
   */
  variant: "inactive" | "active";
  /**
   * The aria-label of the CarouselControl.
   * @type string
   */
  "aria-label"?: string;
  /**
   * The boolean that determines if the CarouselControl is disabled.
   * @type boolean
   * @optional
   * @default false
   */
  disabled?: boolean;
  /**
   * A callback function that is invoked when a dot is clicked.
   * @type () => void
   * @required
   */
  onClick: () => void;
}

export function CarouselControl(props: Readonly<CarouselControlProps>) {
  return (
    <Box
      tabIndex={0}
      className={classNames(
        "group rounded-none focus-visible:outline focus-visible:outline-interactive-black focus-visible:outline-offset-2",
      )}
      onClick={props.onClick}
      vAlignContent="center"
    >
      <Box
        vAlignContent="center"
        hAlignContent="center"
        aria-disabled={props.disabled}
        className={classNames("h-fit w-[12px] rounded-full outline-none", props.className, {
          "bg-base-grey": props.disabled,
          "!h-[32px]": props.variant === "active",
        })}
        data-test-id={props["data-test-id"]}
      >
        <div
          className={classNames("w-[12px] h-[12px] rounded-full", {
            "bg-interactive-yellow border-2 !border-base-dark-grey !h-[32px]": props.variant === "active",
            "bg-base-dark-grey": props.variant === "inactive",
          })}
        />
      </Box>
    </Box>
  );
}
